import { Role } from '@/hooks/useRoles.ts';
import { RouteObject } from 'react-router';

type ExtendedRouteObject = RouteObject & {
	requiredRoles?: Role[];
};

export const filterRoutesByRoles = (routes: ExtendedRouteObject[], userRoles: Role[]) => {
	return routes.filter(route => {
		if (!route?.requiredRoles) return true;
		return route.requiredRoles.some((role: Role) => {
			return userRoles.includes(role);
		});
	});
};
